export type SelectOption<T extends string | number = number> = {
  label: string
  value: T
}

function normalizeLabel(label: string) {
  return label.toLocaleLowerCase()
}

export function compareLabelsCaseInsensitive(a: string, b: string) {
  return normalizeLabel(a).localeCompare(normalizeLabel(b))
}

export function sortOptionsByLabel<T extends string | number>(
  options: SelectOption<T>[],
) {
  return [...options].sort((a, b) =>
    compareLabelsCaseInsensitive(a.label, b.label),
  )
}

export function sortSelectedValues<T extends string | number>(
  values: T[],
  options: SelectOption<T>[],
) {
  const optionLabels = new Map(
    options.map((option) => [option.value, normalizeLabel(option.label)]),
  )

  return [...values].sort((a, b) =>
    (optionLabels.get(a) ?? '').localeCompare(optionLabels.get(b) ?? ''),
  )
}

export function sortItemsByLabel<T>(items: T[], getLabel: (item: T) => string) {
  return [...items].sort((a, b) =>
    compareLabelsCaseInsensitive(getLabel(a), getLabel(b)),
  )
}
